import React from 'react';
import { useAppContext } from '../../contexts/MarketPerformanceContext';
import { truncateNumber } from '../../utilities/Utils';
import {VoidState} from "../../utilities/VoidState";

function PerformanceMetrics() {
    const { state: { marketIndex } } = useAppContext();

    if (!marketIndex.highlights || marketIndex.highlights.length === 0) {
        return (
            <VoidState message='Performance metrics not available' classes='performance-metrics-container' />
        );
    }

    return (
        <div className="performance-metrics-container fb-mb-7">
            <div className="metrics mt-3 mt-lg-0">
                <div className="metrics-label">Rises</div>
                <div className="metrics-value">
                    {marketIndex.highlights.rises}
                </div>
            </div>
            <div className="metrics mt-3 mt-lg-0">
                <div className="metrics-label">Falls</div>
                <div className="metrics-value">
                    {marketIndex.highlights.falls}
                </div>
            </div>
            <div className="metrics mt-3 mt-lg-0">
                <div className="metrics-label">Volume</div>
                <div className="metrics-value">
                    {truncateNumber(marketIndex.highlights.volume)}
                </div>
            </div>
            <div className="metrics mt-3 mt-lg-0">
                <div className="metrics-label">Turnover</div>
                <div className="metrics-value">
                    {truncateNumber(marketIndex.highlights.turnover.amount)}
                    {" " + marketIndex.highlights.turnover.currency}
                </div>
            </div>
        </div>
    );
}

export default PerformanceMetrics;
